export default function SectionHeader({ overline, title, subtitle, align = "left" }) {
  return (
    <div
      className={`max-w-3xl mb-12 ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <div className="overline mb-4">{overline}</div>}
      <h2 className="font-tactical text-4xl md:text-5xl font-bold uppercase tracking-tight text-white">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-zinc-400 text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
